export const QUANTITY_PICKER_INTERACTION_BUTTON = 'button';
export const QUANTITY_PICKER_INTERACTION_INPUT = 'input';
